import { observable, action, computed, makeObservable, override } from 'mobx';

import type { Optional } from 'chaika-common-types';

import { Menu } from './Menu';

export class ItemMenu<T = any, I = number> extends Menu {
    @observable protected itemsMap: Map<I | number, T> = new Map();
    @observable private selectedIndex_: Optional<I>;

    constructor() {
        super();
        makeObservable(this);
    }

    @computed
    public get selectedIndex(): Optional<I> {
        return this.selectedIndex_;
    }

    @computed
    public get keys(): (I | number)[] {
        return Array.from(this.itemsMap.keys());
    }

    @computed
    public get items(): T[] {
        return Array.from(this.itemsMap.values());
    }

    public set selectedIndex(index: Optional<I>) {
        this.selectedIndex_ = index;
    }

    public set items(items: T[]) {
        this.itemsMap.clear();

        items.forEach((item, index) => {
            this.setItem(item, index);
        });

        this.selectedIndex_ = undefined;
    }

    @override
    public toggleIsLeftMenuOpen(): void {
        this.isOpen = !this.isOpen;
    }

    @action
    public setItems(items: T[]): void {
        items.forEach((item, index) => {
            this.setItem(item, index);
        });
    }

    public getItem(index: I): Optional<T> {
        return this.itemsMap.get(index);
    }

    public getSelectedItem(): Optional<T> {
        return this.selectedIndex === undefined ? undefined : this.itemsMap.get(this.selectedIndex);
    }

    protected setItem(item: T, index: I | number) {
        this.itemsMap.set(index, item);
    }
}
